import 'bootstrap/dist/css/bootstrap.min.css'

// Self-hosted fonts (replaces render-blocking fonts.googleapis.com stylesheet).
// Weights mirror the previous gatsby-plugin-google-fonts config; @fontsource
// ships font-display: swap and unicode-range subsets by default.
import '@fontsource/poppins/300.css'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/400-italic.css'
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'
import '@fontsource/poppins/900.css'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/400-italic.css'
import '@fontsource/roboto/700.css'
import '@fontsource/roboto/900.css'

import PageElement from 'src/services/PageElement'
import StoreProvider from 'src/services/StoreProvider'
import { redirectToPlansPageFromJourneyMiddle } from 'src/utils/on-page-reload-helper'

export const wrapRootElement = StoreProvider

export const onClientEntry = () => {
  window.onload = () => redirectToPlansPageFromJourneyMiddle()
}

// Wraps every page in a component
export const wrapPageElement = PageElement
